module.exports = __webpack_public_path__ + "static/media/being_one.50d87048.png";